import { Phone, Mail, MapPin } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { BUSINESS } from "@/data/services";

const Footer = () => (
  <footer data-testid="main-footer" className="relative border-t border-edge bg-surface/30 overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 pt-16 pb-10 relative z-10">
      <div className="grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="Elite Rims & Trims logo" className="w-12 h-12 rounded-full ring-1 ring-edge object-cover" />
            <div className="font-syne font-extrabold uppercase tracking-widest text-lg text-slate-100">
              Elite Rims <span className="text-volt">&amp;</span> Trims
            </div>
          </div>
          <p className="mt-3 text-sm text-slate-400 max-w-xs leading-relaxed">
            {BUSINESS.tagline}. All prices + GST.
          </p>
        </div>
        <div>
          <div className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-slate-500 mb-4">Navigate</div>
          <div className="flex flex-col gap-2.5">
            {[
              ["Services", "services", "footer-link-services"],
              ["Instant Estimate", "estimator", "footer-link-estimator"],
              ["The Standard", "manifesto", "footer-link-manifesto"],
              ["Before & After", "gallery", "footer-link-gallery"],
              ["Service Area", "service-area", "footer-link-service-area"],
              ["Book a Service", "booking", "footer-link-booking"],
            ].map(([label, id, testid]) => (
              <button
                key={id}
                data-testid={testid}
                onClick={() => scrollToId(id)}
                className="text-left text-sm text-slate-400 hover:text-volt transition-colors w-fit"
              >
                {label}
              </button>
            ))}
          </div>
        </div>
        <div>
          <div className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-slate-500 mb-4">Contact</div>
          <div className="flex flex-col gap-3">
            <a
              data-testid="footer-phone"
              href={`tel:${BUSINESS.phone}`}
              className="flex items-center gap-3 text-sm text-slate-300 hover:text-volt transition-colors w-fit"
            >
              <Phone size={14} className="text-volt" /> {BUSINESS.phone}
            </a>
            <a
              data-testid="footer-email"
              href={`mailto:${BUSINESS.email}`}
              className="flex items-center gap-3 text-sm text-slate-300 hover:text-volt transition-colors w-fit break-all"
            >
              <Mail size={14} className="text-volt shrink-0" /> {BUSINESS.email}
            </a>
            <div className="flex items-center gap-3 text-sm text-slate-500">
              <MapPin size={14} className="text-volt shrink-0" /> Fully mobile · Wanneroo to Serpentine
            </div>
          </div>
        </div>
      </div>
      <div className="mt-14 pt-6 border-t border-edge flex flex-col sm:flex-row items-center justify-between gap-3">
        <span className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-slate-600">
          © {new Date().getFullYear()} Elite Rims &amp; Trims. All rights reserved.
        </span>
        <a
          data-testid="footer-admin-link"
          href="/admin"
          className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-slate-600 hover:text-volt transition-colors"
        >
          Team Login
        </a>
      </div>
    </div>
    <div
      aria-hidden="true"
      className="pointer-events-none select-none absolute -bottom-10 left-1/2 -translate-x-1/2 font-syne font-extrabold uppercase text-[22vw] leading-none text-outline opacity-[0.07] whitespace-nowrap"
    >
      Elite
    </div>
  </footer>
);

export default Footer;
